export default __webpack_public_path__ + "static/media/215.b014e397.png";